<template>
	<div>
		<h1>Workflow</h1>

        <b-form inline v-if="!simplify">
            <b-input-group prepend="Nom">
                <b-form-input v-model="name"></b-form-input>
            </b-input-group>
            <b-input-group prepend="Version">
                <b-form-input v-model="version"></b-form-input>
            </b-input-group>
            <b-button v-b-modal="'modal' + id">Charger</b-button>
            <b-button v-if="!simplify" @click="save_db" :disabled="!version || !name"
                ><i class="fas fa-save"></i
            ></b-button>
            <b-button v-b-modal="'modal_file' + id">Fichier</b-button>
            <b-button v-b-modal="'modal_rename' + id">Renommer</b-button>
        </b-form>

        <div v-if="simplify">
            <v-select
                v-model="load_name"
                :options="names"></v-select>
        </div>

        <b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
            <span>Nom</span>
            <v-select
                v-model="load_name"
                :options="names"></v-select>
            <span>Version</span>
            <v-select
                v-model="load_version"
                :options="versions"></v-select>
        </b-modal>

        <b-modal
            :hide-footer="true"
            :id="'modal_file' + id"
            title="Fichier">
            <b-file
                accept=".json"
                @change="load_file"
                placeholder="charger (fichier)"></b-file>
            <br /><br />
            <b-button @click="save_file">sauvergarder (fichier)</b-button>
        </b-modal>

        <b-modal
            :hide-footer="true"
            :id="'modal_rename' + id"
            title="Renommer">
            <p>Nouveau nom</p>
            <b-input v-model="new_name"></b-input>
            <br />
            <b-button @click="rename">Rennomer</b-button>
        </b-modal>

        <div v-show="name && simplify">
            <br />
            <b-button @click="hide_drawflow ? hide_drawflow = false : hide_drawflow = true">{{hide_drawflow ? 'Voir les blocs' : 'Cacher les blocs' }}</b-button> 
            <br /><br v-show="!hide_drawflow"/>
        </div>
        <b-container :style="'margin: 0; padding: 0; max-width: none;' + (hide_drawflow ? 'position: absolute; top: -10000px;' : '')">
            <b-row>
                <b-col :cols="simplify ? 12 : 10">
                    <div id="drawflow"></div>
                </b-col>
                <b-col v-show="!simplify" :cols="2">
                    <b-button style="margin: 2px" @click="add('create')"><i class="fas fa-plus"></i> projet</b-button>
                    <b-button style="margin: 2px" @click="add('data')"><i class="fas fa-plus"></i> données</b-button>
                    <b-button style="margin: 2px" @click="add('validation')"><i class="fas fa-plus"></i> validation</b-button>
                    <b-button style="margin: 2px" @click="add('step')"><i class="fas fa-plus"></i> étape</b-button>
                    <b-button style="margin: 2px" @click="add('treatment')"><i class="fas fa-plus"></i> traitement</b-button>
                    <hr />
                    <div v-for="(node, key) in nodes" :index="key">
                        <div v-show="selection == node.uid">
                            Nom du bloc
                            <b-input v-model="node.description" @input="set_description_node(node.id, node.description, true)"></b-input>
                            Description
                            <b-textarea :rows="7" v-model="node.long_description" />
                            <b-checkbox v-model="node.start">Bloc de départ</b-checkbox>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <br />

        <div v-for="(node, key) in nodes" :index="key">
            <div v-show="selection == node.uid">
                <div v-if="node.connections.filter(value => value.input_id == node.id).length">Bloc{{ node.connections.filter(value => value.input_id == node.id).length <= 1 ? "" : "s" }} précédent{{ node.connections.filter(value => value.input_id == node.id).length <= 1 ? "" : "s" }}</div>
                <span v-for="(connection, connection_idx) in node.connections" :index="connection_idx">
                    <span v-if="connection.input_id == node.id">
                        <b-button style="margin:5px" @click="set_selection(connection.output_uid)">{{nodes[connection.output_uid].title}} {{ nodes[connection.output_uid].description }}</b-button>
                    </span>
                </span>
                <create v-if="node.type == 'create'" @add_project_workflow="add_project_workflow" :node_workflow="node" :worflow_builder="!simplify" :default_project="node.params.project" :workflow_in_nb="node.in_nb" :workflow="node.id" :ref="'node' + node.id" @set_data_in="set_data_in" @set_description_node="set_description_node" @set_state_node="set_state_node"/>
                <treatment_selector v-if="node.type == 'treatment'" @add_project_workflow="add_project_workflow" :node_workflow="node" :worflow_builder="!simplify" :workflow="node.id" :ref="'node' + node.id" :p_project="node.params.project" @set_data_in="set_data_in" @set_description_node="set_description_node" @set_state_node="set_state_node"/>
                <validation v-if="node.type == 'validation'" :workflow="node.id" :node_workflow="node" :worflow_builder="!simplify" :workflow_in_nb="node.in_nb" :ref="'node' + node.id" :_name="node.params.name" @set_data_in="set_data_in" @set_description_node="set_description_node" @set_state_node="set_state_node"/>
                <data_component v-if="node.type == 'data'" :workflow="node.id" :node_workflow="node" :worflow_builder="!simplify" :ref="'node' + node.id" @set_data_in="set_data_in" @set_description_node="set_description_node" @set_state_node="set_state_node"/>
                <step_workflow v-if="node.type == 'step'" :workflow="node.id" :node_workflow="node" :worflow_builder="!simplify" :ref="'node' + node.id" />
                <hr />
                <div v-if="node.connections.filter(value => value.output_id == node.id).length">Bloc{{ node.connections.filter(value => value.output_id == node.id).length <= 1 ? "" : "s" }} suivant{{ node.connections.filter(value => value.output_id == node.id).length <= 1 ? "" : "s" }}</div>
                <span v-for="(connection, connection_idx) in node.connections" :index="connection_idx">
                    <span v-if="connection.output_id == node.id">
                        <b-button style="margin:5px" @click="set_selection(connection.input_uid)" v-if="connection.output_id == node.id">{{nodes[connection.input_uid].title}} <br /> {{ nodes[connection.input_uid].description }}</b-button>
                    </span>
                </span>
            </div>
        </div>
	</div>
</template>

<script>
    import Vue from 'vue';
    import Drawflow from 'drawflow';
    import styleDrawflow from 'drawflow/dist/drawflow.min.css'

    import Workflow_component from './Workflow_component.vue';
    import library from "../services/library.js";
	import utils from "../services/utils.js";
	import store from "../store";

    var clone = require("clone");

	export default {
		name: "workflow",
        component: {
        },
		data() {
			return {
                user: {},
                type: "workflow",
                name: "",
                new_name: "",
                names: [],
                version: "",
                load_name: "",
                load_version: "",
                versions: [],

                refs: {},
                refs_uid: {},
                refs_id: {},
                uid: this.$uuid.v4(),
                id: this.$uuid.v4(),
                nodes: {},
                editor: null,
                selection: null,
                simplify: false,
                hide_drawflow: false
			};
		},
        watch: {
			$route() {
                if (this.$route.params.mode)
                {
                    this.simplify = true;
                    this.hide_drawflow = true;
                    this.editor.editor_mode = "view";
                }
                else
                    this.simplify = false;
                    this.hide_drawflow = false;
                    this.editor.editor_mode = "edit";
            },
			load_name: {
				async handler() {
					var elements = await library.getby_libelle(
						this.load_name,
						this.type
					);
					elements = elements.element;

					this.versions = [];
					for (var i = 0; i < elements.length; i++) {
						if (i == 0) {
							if (
								this.load_version &&
								this.load_version == elements[i].version
							)
								await this.load_db();
							this.load_version = elements[i].version;
						}
						this.versions.push(elements[i].version);
					}
				},
			},
			load_version: {
				async handler() {
					if (this.load_version) await this.load_db();
				},
			},
        },
		methods: {
            async set_selection(uid)
            {
                console.log("set_selection " + uid)
                this.selection = uid;
                this.classSelect(this.refs_uid[this.selection]);
            },
            async set_description_node(node, description, user = false)
            {
                if (!this.nodes[this.refs_id[node]].description || user)
                {
                    var div = document.getElementById('node-' + node);
                    this.nodes[this.refs_id[node]].description = description;

                    div.getElementsByClassName('description')[0].innerHTML = description;
                }

                //console.log("set_description_node")
                //console.log('node-' + node)

                /*this.editor.updateConnectionNodes('node-' + node);*/
            },
            async set_state_node(node, state)
            {
                var div = document.getElementById('node-' + node);
            },
			async load_db() {
				document.body.style.cursor = "wait";
				var result = await library.load(
					this.load_name,
					this.load_version,
					this.type
				);
				this.name = this.load_name;
				this.version = this.load_version;
				await this.load(result);
				document.body.style.cursor = "default";
			},
			async load_file(event) {
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return function (e) {
						var data = JSON.parse(e.target.result);
						self.load(data);
					};
				})(file);

				reader.readAsText(file);
			},
			async rename() {
				console.log("rename");
				await library.rename(this.type, this.name, this.new_name);
				this.name = this.new_name;
				this.save_db();
			},
			async set_name() {
				var names = await library.getby_production(this.type);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].name);
				}
			},
			async save_db() {
				var data = await this.save();

				await library.save(this.name, this.version, data, this.type, this.user.env || null, {}, true);
				await this.set_name();

				this.$notify({
					group: "info",
					title: "Enrgistrement en base effectué",
					type: "success",
				});
			},
            async save_file()
            {
                var data = await this.save();

                utils.saveToFile(
					JSON.stringify(data),
					(this.name ? this.name : this.type) + ".json"
				);
            },
            async save()
            {
                var data = {};

                var nodes = clone(this.nodes);

                var keys = Object.keys(nodes);
                for (var i = 0; i < keys.length; i++)
                {
                    nodes[keys[i]].params = await this.$refs["node" + nodes[keys[i]].id][0].save_workflow();
                    var node = this.editor.getNodeFromId(nodes[keys[i]].id);
                    nodes[keys[i]].pos_x = node.pos_x;
                    nodes[keys[i]].pos_y = node.pos_y;
                    nodes[keys[i]].inputs = node.inputs;
                    var node_keys = Object.keys(nodes[keys[i]].inputs);
                    for (var j = 0; j < node_keys.length; j++)
                    {
                        for (var k = 0; k < node.inputs[node_keys[j]].connections.length; k++)
                        {
                            node.inputs[node_keys[j]].connections[k].output_uid = this.refs_id[node.inputs[node_keys[j]].connections[k].node];
                            node.inputs[node_keys[j]].connections[k].input_uid = keys[i];
                            node.inputs[node_keys[j]].connections[k].output = node.inputs[node_keys[j]].connections[k].input;
                            node.inputs[node_keys[j]].connections[k].input = node_keys[j];

                            delete node.inputs[node_keys[j]].connections[k].node;
                        }
                    }
                    nodes[keys[i]].outputs = node.outputs;
                    var node_keys = Object.keys(nodes[keys[i]].outputs);
                    for (var j = 0; j < node_keys.length; j++)
                    {
                        for (var k = 0; k < node.outputs[node_keys[j]].connections.length; k++)
                        {
                            node.outputs[node_keys[j]].connections[k].input_uid = this.refs_id[node.outputs[node_keys[j]].connections[k].node];
                            node.outputs[node_keys[j]].connections[k].output_uid = keys[i];
                            node.outputs[node_keys[j]].connections[k].input = node.outputs[node_keys[j]].connections[k].output;
                            node.outputs[node_keys[j]].connections[k].output = node_keys[j];

                            delete node.outputs[node_keys[j]].connections[k].node;
                        }
                    }
                }

                data.nodes = nodes;

                return data;
            },
            async load(data)
            {
                var nodes = this.nodes;
                var keys = Object.keys(nodes);
                for (var i = 0; i < keys.length; i++)
                {
                    this.editor.removeNodeId("node-" + nodes[keys[i]].id);
                }

                await this.$nextTick();

                var keys = Object.keys(data.nodes);
                var start = null;
                for (var i = 0; i < keys.length; i++)
                {
                    console.log(data.nodes[keys[i]])
                    var node = this.add(data.nodes[keys[i]].type, data.nodes[keys[i]].params, data.nodes[keys[i]].uid, data.nodes[keys[i]].pos_x, data.nodes[keys[i]].pos_y, data.nodes[keys[i]].start, data.nodes[keys[i]].description || "", data.nodes[keys[i]].long_description || "")
                    data.nodes[keys[i]].id = node.id;
                    if (data.nodes[keys[i]].start)
                        start = data.nodes[keys[i]].uid;
                }

                await this.$nextTick();

                var keys = Object.keys(data.nodes);
                for (var i = 0; i < keys.length; i++)
                {
                    if (this.$refs["node" + data.nodes[keys[i]].id] && this.$refs["node" + data.nodes[keys[i]].id][0])
                    {
                        await this.$refs["node" + data.nodes[keys[i]].id][0].load_workflow(data.nodes[keys[i]].params);
                        //await this.set_description_node(data.nodes[keys[i]].id, data.nodes[keys[i]].description, true);
                    }

                    var node_keys = Object.keys(data.nodes[keys[i]].inputs);
                    for (var j = 0; j < node_keys.length; j++)
                    {
                        for (var k = 0; k < data.nodes[keys[i]].inputs[node_keys[j]].connections.length; k++)
                        {
                            var connection = data.nodes[keys[i]].inputs[node_keys[j]].connections[k];
                            this.editor.addConnection(this.refs_uid[connection.output_uid], this.refs_uid[connection.input_uid], connection.output, connection.input);
                        }
                    }
                }

                await this.$nextTick();

                if (start)
                {
                    this.selection = start;
                    this.classSelect(this.refs_uid[this.selection]);
                }

                this.editor.node_selected = null;
                this.editor.dispatch('nodeUnselected', true);
            },
            async classSelect(id)
            {
                var self = this;

                await this.$nextTick();

                var keys = Object.keys(self.nodes);
                for (var i = 0; i < keys.length; i++)
                {
                    var node = self.nodes[keys[i]];
                    var div = document.getElementById('node-' + node.id);
                    if (node.id == id)
                    {
                        div.getElementsByClassName('workflow_component')[0].parentNode.classList.add("select");                
                    }
                    else
                    {
                        div.getElementsByClassName('workflow_component')[0].parentNode.classList.remove("select");                
                    }
                }
            },
            async add_project_workflow(node, project_uid)
            {

                this.add("create", {project: project_uid});

                var id = this.refs_uid[this.selection];

                this.editor.addConnection(node, id, 'output_1', 'input_1');
            },
            async set_data_in(node)
            {
                console.log("set_data_in " + node)

                var data = await this.$refs["node" + node][0].get_data_out();

                if (data.length == 0)
                    this.nodes[this.refs_id[node]].data = false;
                else if (data[0].data && data[0].data instanceof Blob && data[0].data.size == 0)
                    this.nodes[this.refs_id[node]].data = false;
                else
                {
                    this.nodes[this.refs_id[node]].data = true;
                }


                var outputs = this.editor.getNodeFromId(node).outputs;

                var keys = Object.keys(outputs);
                for (var i = 0; i < keys.length; i++)
                {
                    for (var j = 0; j < outputs[keys[i]].connections.length; j++)
                    {                        
                        if (this.$refs["node" + outputs[keys[i]].connections[j].node][0])
                        {
                            await this.$refs["node" + outputs[keys[i]].connections[j].node][0].get_data_in();
                        }
                    }
                }
            },
            async get_data_in(node)
            {
                console.log("get_data_in " + node)

                var inputs = this.editor.getNodeFromId(node).inputs;

                var files = [];

                var keys = Object.keys(inputs);
                for (var i = 0; i < keys.length; i++)
                {
                    for (var j = 0; j < inputs[keys[i]].connections.length; j++)
                    {
                        var data = await this.$refs["node" + inputs[keys[i]].connections[j].node][0].get_data_out();
                        if (data)
                        {
                            files = files.concat(data);
                        }
                    }
                }

                return files;
            },
            add(type = "create", params = {}, uid = null, x = null, y = null, start = false, description = "", long_description = "")
            {
                if (x === null && y === null)
                {
                    x = 100;
                    y = 200;
                    if (this.selection)
                    {
                        var id_selection = this.refs_uid[this.selection];
                        var node = this.editor.getNodeFromId(id_selection);
                        x = node.pos_x + 400;
                        y = node.pos_y;                    
                    }
                }

                if (!uid)
                    uid = this.$uuid.v4();

                var node = {
                    uid, 
                    in_nb: 0, 
                    params, 
                    start, 
                    connections: [], 
                    description: description,
                    long_description: long_description,
                    data: false
                };

                if (type == "create")
                {  
                    var id_node = this.editor.addNode('project', 1, 1, x, y, 'cp', {}, 'component', 'vue');
                    
                    node.type = "create";
                    node.title = "Projet";
                }
                if (type == "data")
                {  
                    var id_node = this.editor.addNode('data', 1, 1, x, y, 'cp', {}, 'component', 'vue');
                   
                    node.type = "data";
                    node.title = "Données";
                }
                if (type == "step")
                {  
                    var id_node = this.editor.addNode('step', 1, 1, x, y, 'cp', {}, 'component', 'vue');
                    
                    node.type = "step";
                    node.title = "Etape";
                }
                if (type == "treatment")
                {  
                    var id_node = this.editor.addNode('treatment', 0, 1, x, y, 'cp', {}, 'component', 'vue');
                    
                    node.type = "treatment";
                    node.title = "Traitement";
                }
                if (type == "validation")
                {  
                    var id_node = this.editor.addNode('validation', 1, 1, x, y, 'cp', {}, 'component', 'vue');

                    node.type = "validation";
                    node.title = "Validation";
                }


                this.refs_id[id_node] = uid;
                this.refs_uid[uid] = id_node;

                node.id = id_node;
                this.$set(this.nodes, uid, node);

                var div = document.getElementById('node-' + id_node);

                //var height = div.getBoundingClientRect().height;

                div.getElementsByClassName('title')[0].innerHTML = node.title + "";
                div.getElementsByClassName('description')[0].innerHTML = node.description + "";

                //height = height - div.getBoundingClientRect().height;

                //console.log(height)

                /* // Pour redimensionnement
                
                var id = id_node;
                const links =  document.querySelectorAll(`#node-${id} .drawflow_content_node .link`);
                links.forEach((item, idx) => {
                    console.log(idx)
                    var target = document.querySelector(`#node-${id} .outputs .${item.classList[1]}`);
                    if(target != null) {
                        const pos = item.getBoundingClientRect();
                        const targetPos = target.getBoundingClientRect();
                        target.style.top = `${pos.y - targetPos.y}px`;
                    }
                    target = document.querySelector(`#node-${id} .inputs .${item.classList[1]}`);
                    if(target != null) {
                        const pos = item.getBoundingClientRect();
                        const targetPos = target.getBoundingClientRect();
                        target.style.top = `${pos.y - targetPos.y + 30}px`;
                    }
                })*/

                this.selection = uid;

                return node;
            }            
		},
		mounted: async function () {

            this.user = store.state.user;
            if (store.state.user.rules && !store.state.user.rules.workflow) {
				this.$router.push({ name: "profile" });
			}    
            
            var self = this;
            
            const id = document.getElementById('drawflow')
            this.editor = new Drawflow(id, Vue)

            var editor = this.editor;


            if (this.$route.params.mode)
            {
                this.simplify = true;
                this.hide_drawflow = true;
                this.editor.editor_mode = "view";
            }

            this.set_name();

            editor.registerNode('component', Workflow_component, {}, {});

            editor.on('nodeCreated', (id) => {
                const links =  document.querySelectorAll(`#node-${id} .drawflow_content_node .link`);
                links.forEach((item) => {
                    var target = document.querySelector(`#node-${id} .outputs .${item.classList[1]}`);
                    if(target != null) {
                        const pos = item.getBoundingClientRect();
                        const targetPos = target.getBoundingClientRect();
                        target.style.top = `${pos.y - targetPos.y}px`;
                        target.style.left = `${pos.x - targetPos.x}px`;
                    }
                    target = document.querySelector(`#node-${id} .inputs .${item.classList[1]}`);
                    if(target != null) {
                        const pos = item.getBoundingClientRect();
                        const targetPos = target.getBoundingClientRect();
                        target.style.top = `${pos.y - targetPos.y}px`;
                        target.style.left = `5px`;
                    }
                })
                var evt = new MouseEvent("mousedown", {
                    view: window,
                    bubbles: true,
                    cancelable: false,
                });
                var evt2 = new MouseEvent("mouseup", {
                    view: window,
                    bubbles: true,
                    cancelable: false,
                });
                
                document.querySelector(`#node-${id} .drawflow_content_node`).dispatchEvent(evt);
                document.querySelector(`#node-${id} .drawflow_content_node`).dispatchEvent(evt2);
            })

            editor.on('nodeRemoved', (id) => {
                var uid = self.refs_id[id];
                delete self.refs_id[id]; 
                delete self.refs_uid[uid]; 
                delete self.nodes[uid];
                this.selection = null;
            });


            editor.on("click", function(event) {
                if (self.simplify)
                {
                    if(event.target.tagName === "DIV" && !event.target.className.startsWith("output") && !event.target.className.startsWith("input")) {
                        self.editor.editor_mode = 'edit';
                    } 
                }
            });

            editor.on("clickEnd", function(event) {
                if (self.simplify)
                    self.editor.editor_mode = 'view';

            });

            editor.on('nodeSelected', (id) => {
                self.selection = self.refs_id[id];

                self.classSelect(id);
            })

            editor.on('connectionCreated', (obj) => {
                this.nodes[this.refs_id[obj.input_id]].in_nb++;
                
                obj.id = obj.input_class + "|" + obj.input_id + "|" + obj.output_class + "|" + obj.output_id;
                obj.input_uid = this.refs_id[obj.input_id];
                obj.output_uid = this.refs_id[obj.output_id];
                this.nodes[this.refs_id[obj.input_id]].connections.push(obj);
                this.nodes[this.refs_id[obj.output_id]].connections.push(obj);

                if (this.$refs["node" + this.nodes[this.refs_id[obj.input_id]].id][0].get_data_in)
                    this.$refs["node" + this.nodes[this.refs_id[obj.input_id]].id][0].get_data_in()
            });

            editor.on('connectionRemoved', (obj) => {

                var node = this.nodes[this.refs_id[obj.input_id]];
                var id = obj.input_class + "|" + obj.input_id + "|" + obj.output_class + "|" + obj.output_id;
                for (var i = 0; i < node.connections.length; i++)
                {
                    if (node.connections[i].id == id)
                        node.connections.splice(i, 1);
                }
                var node = this.nodes[this.refs_id[obj.output_id]];
                var id = obj.input_class + "|" + obj.input_id + "|" + obj.output_class + "|" + obj.output_id;
                for (var i = 0; i < node.connections.length; i++)
                {
                    if (node.connections[i].id == id)
                        node.connections.splice(i, 1);
                }

                this.nodes[this.refs_id[obj.input_id]].in_nb--;
            });

            editor.start();

            //this.add();

        },
	};
</script>

<style>
#container {
  background-color: #003049;
  width: 90%;
  height: 500px;
  margin: 0 auto;
  border: 5px solid #003049;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-wrap:wrap;
}

    #drawflow { 
      position: relative;
      text-align:initial;
      width: 100%;
      height: 400px;
      border: 1px solid red;
      font-size: 14px;
    }
    .multiple {
        border-radius: 4px;
    }
    .multiple .panel {
        margin: 0px;
        border-radius: 0px;
    }
    .panel {
        display: block;
        position: relative;
        background: white;
        padding: 10px;
        margin: 10px 0px;
        border-radius: 4px;
        border: 1px solid #eaeef3;
    }

    .link {
        position: absolute;
        right: -1px;
        top: 15px;
        
        display: block;
        width: 10px;
        height: 10px; 
    }

    .drawflow .drawflow-node .output, .drawflow .drawflow-node .input  {
        width: 8px;
        height: 8px;
        border: 2px solid #75889a;
    }

    .drawflow .inputs {
        position: absolute;
        top: 10px;
        opacity: 1;
    }
    .drawflow .outputs {
        position: absolute;
        top: 10px;
        opacity: 1;
    }
    .drawflow .connection .main-path {
        stroke-width: 2px;
    }

    .drawflow .drawflow-node {
        border: 2px solid white;
        width: 260px;
        
    }
    .drawflow .drawflow-node .title {
        font-weight: bold;
    }

    .drawflow-node.cp {
        outline: 2px solid #eaeef3;
        background: #eaeef3;
    }
    .drawflow-node.project .title {
        color: #75889a;
    }

    .drawflow-node.yes {
        outline: 2px solid #e9f0e9;
        background: #e9f0e9;
    }
    .drawflow-node.yes .title {
        color: #758375;
    }

    .drawflow-node.newblock .inputs {
        top: 50px;
    }
    .drawflow-node.newblock {
        outline: 2px solid #eaeef3;
        background: #eaeef3;
    }
    .drawflow-node.newblock .title {
        color: #75889a;
    }

    .drawflow-node.no .inputs {
        top: 50px;
    }
    .drawflow-node.no {
        outline: 2px solid #ffdee6;
        background: #ffdee6;
    }
    .drawflow-node.no .title {
        color: #ad516a;
    }
    .drawflow .drawflow-node {
        z-index: initial;
    }

    .drawflow .drawflow-node.selected {
        background: inherit
    }

    .selected {
        text-decoration: none !important
    }
    
</style>
